<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { computed } from "vue";
import { RouterLink, useRoute } from "vue-router";

import { useUser } from "@/composables/api/useUser";

import SubmitReceipt from "@/components/sections/submit-receipt/SubmitReceipt.vue";

const { data: user } = useUser();
const links = computed(() => {
  if (user.value?.current_mechanic === "lactel") {
    return [
      { label: "home.navigation.vouchers", name: "vouchers" },
      { label: "home.navigation.gifts", name: "gifts" },
      { label: "home.navigation.receipts", name: "receipts" },
    ];
  }
  return [
    { label: "home.navigation.gifts", name: "gifts" },
    { label: "home.navigation.vouchers", name: "vouchers" },
    { label: "home.navigation.receipts", name: "receipts" },
  ];
});

const route = useRoute();
</script>

<template>
  <nav
    id="navigation-menu"
    :class="
      twMerge(
        'hide-scrollbar bg-galbani sticky top-0 z-[2] flex w-full items-center gap-8 overflow-x-auto px-6 pt-6 lg:justify-center lg:gap-16',
        user?.current_mechanic === 'lactel' && 'bg-lactel-blue-light',
      )
    "
    role="navigation"
    aria-label="Menu principal"
  >
    <ul class="m-0 flex list-none items-center gap-8 p-0 lg:gap-16">
      <li v-for="link in links" :key="link.label" class="flex flex-col gap-5">
        <RouterLink
          :to="{ name: link.name }"
          :class="
            twMerge(
              'font-brygada text-[20px] font-bold whitespace-nowrap text-white transition-colors duration-300 ease-out lg:text-[28px]',
              user?.current_mechanic === 'lactel' && 'font-mitr',
              route.name === link.name && user?.current_mechanic !== 'lactel' && 'text-topchef',
              user?.current_mechanic === 'lactel' && 'text-lactel-blue',
            )
          "
          :aria-current="route.name === link.name ? 'page' : undefined"
        >
          {{ $t(link.label) }}
        </RouterLink>

        <span
          :class="
            twMerge(
              'bg-topchef block h-0.5 w-full transition-opacity duration-300 ease-out lg:h-1',
              user?.current_mechanic === 'lactel' && 'bg-lactel-yellow h-2',
              route.name === link.name ? 'opacity-100' : 'opacity-0',
            )
          "
          aria-hidden="true"
        />
      </li>

      <SubmitReceipt
        :buttonClass="
          user?.current_mechanic === 'lactel'
            ? 'hidden lg:flex mb-[18px] lg:border-none'
            : 'hidden lg:flex mb-[18px]'
        "
      />
    </ul>
  </nav>
</template>

<style lang="css" scoped>
.hide-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>
